import { FC } from "react"

import CustomLineChart from "../customLineChart";
import CustomButtonRight from "../customButtonRight";

import { StatisticsObjectType } from "./types";


const CaseVolume: FC<StatisticsObjectType> = ({ StatisticsObjectType, buttonShows, queryParams }): JSX.Element => {
  return (
      <div className="row mt-2">
          <div className="col">
              {queryParams &&
                  <CustomLineChart title="Cases / Doses" queryParams={queryParams}
                                   LineChartObject={StatisticsObjectType.case_volume}/>
              }
          </div>

          {buttonShows &&
              <div className="mt-3">
                  <CustomButtonRight StatisticsObjectType={StatisticsObjectType}/>
              </div>
          }
      </div>
  )
}
export default CaseVolume;
